import Sharing from '../../shared/ui/Sharing/Sharing';
import Sound from '../../shared/ui/Sound/Sound';
import cls from './EndGame.module.scss';
import standImg from '../../shared/assets/images/stand.svg';
import Bar from '../../widgets/Bar/Bar';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../shared/redux/store';
import { setEndGame, setPage } from '../../shared/redux/pages/slice';
import { nextLocation, setIsNextlocation } from '../../shared/redux/game/slice';
import { nextLevel } from '../../shared/redux/child/slice';
import { Pages } from '../../shared/redux/pages/types';
import notificationMp3 from '../../shared/assets/sound/notification_2.mp3';
import { useEffect, useMemo, useRef } from 'react';
import buttonMp3 from '../../shared/assets/sound/button_2.mp3';
import { againHooks, setCanDoubleHooks, setRandomSpeach } from '../../shared/redux/hooks/slice';

const soundButton = new Howl({
  src: [buttonMp3],
});

const speechArr = [
  <div className={cls.text}>
    <p className={cls.second_p}>
      Упс!
      <br />
      Ребятам не хватило твоей поддержки. Поделись игрой с друзьями и получи еще один шанс.
    </p>
    <p className={cls.first_p}>
      Упс!
      <br />
      Ребятам не хватило твоей поддержки. Поделись игрой с друзьями и получи еще один шанс.
    </p>
  </div>,

  <div className={cls.text}>
    <p className={cls.second_p}>
      Впереди длинный путь!
      <br />
      <br />
      Поделись игрой с друзьями, чтобы подтянуть отстающих.
    </p>
    <p className={cls.first_p}>
      Впереди длинный путь!
      <br />
      <br />
      Поделись игрой с друзьями, чтобы подтянуть отстающих.
    </p>
  </div>,

  <div className={cls.text}>
    <p className={cls.second_p}>
      Впереди длинный путь!
      <br />
      <br />
      Поделись игрой с друзьями, чтобы получить +2 к каждой суперсиле.
    </p>
    <p className={cls.first_p}>
      Впереди длинный путь!
      <br />
      <br />
      Поделись игрой с друзьями, чтобы получить +2 к каждой суперсиле.
    </p>
  </div>,

  <div className={cls.text}>
    <p className={cls.second_p}>
      Ты близко к вершине!
      <br />
      <br />
      Поделись игрой с друзьями, чтобы получить +2 к каждой суперсиле.
    </p>
    <p className={cls.first_p}>
      Ты близко к вершине!
      <br />
      <br />
      Поделись игрой с друзьями, чтобы получить +2 к каждой суперсиле.
    </p>
  </div>,

  <div className={cls.text_special}>
    <p className={cls.second_p}>
      Ты близко к вершине
      <br />
      <br />
      Поднять всех наверх!
    </p>
    <p className={cls.first_p}>
      Ты близко к вершине
      <br />
      <br />
      Поднять всех наверх!
    </p>
  </div>,
];
const buttonText = [
  'Нет сил',
  'Плевать на слабаков',
  'Суперсила во мне',
  'Справлюсь сам',
  'Вперед',
];

const EndGame = () => {
  const dispatch = useDispatch();
  const children = useSelector((state: RootState) => state.children.children);
  const { count, isNextLocation } = useSelector((state: RootState) => state.game);
  const isSound = useSelector((state: RootState) => state.sound.isSound);
  const canDoubleHooks = useSelector((state: RootState) => state.hooks.canDoubleHooks);

  useEffect(() => {
    if (count === 5) {
      dispatch(setPage(Pages.FINAL));
      dispatch(setIsNextlocation(true));
    }
  }, [count]);

  const arrDiedLenght = useMemo(() => {
    return children.filter((el) => el.isDied).length;
  }, [children]);

  const onClickButton = () => {
    if (isSound) {
      soundButton.play();
    }
    dispatch(setEndGame(false));
    if (arrDiedLenght < 6 && count < 5) {
      if (isNextLocation) {
        dispatch(nextLocation());
      }
      dispatch(nextLevel());
      dispatch(setIsNextlocation(true));
      if (canDoubleHooks) {
        dispatch(setCanDoubleHooks(false));
      } else {
        dispatch(againHooks());
      }
    } else {
      dispatch(setPage(Pages.FINAL));
      dispatch(setIsNextlocation(true));
    }
  };

  function getRandomIntInclusive(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const randomNumberFirst = useMemo(() => {
    return getRandomIntInclusive(3, 4);
  }, []);

  const getTextP = () => {
    if (arrDiedLenght === 6) {
      dispatch(setRandomSpeach(0));
      return speechArr[0];
    } else if (arrDiedLenght === 0) {
      if (randomNumberFirst === 3) {
        dispatch(setRandomSpeach(3));
      } else {
        dispatch(setRandomSpeach(4));
      }
      return speechArr[randomNumberFirst];
    } else {
      return speechArr[1];
    }
  };

  const getTextButton = () => {
    if (arrDiedLenght === 6) {
      return buttonText[0];
    } else if (arrDiedLenght === 0) {
      return buttonText[randomNumberFirst];
    } else {
      return buttonText[1];
    }
  };

  useEffect(() => {
    if (isSound) {
      const soundEnd = new Howl({
        src: [notificationMp3],
      });
      soundEnd.play();
    }
  }, []);

  return (
    <div className={cls.Final}>
      <Bar />
      {getTextP()}
      <button onClick={onClickButton}>
        <p>{getTextButton()}</p>
      </button>
      <Sound />
      <Sharing />
      <div className={cls.childrenGroup}>
        {children.map((el, idx) => {
          if (!el.isDied) {
            return <img key={idx} alt="Child" src={el.img} className={`${el.name}_static`} />;
          }
        })}
      </div>
      <img alt="Stand" src={standImg} className={cls.standImage} />
    </div>
  );
};

export default EndGame;
